export const imageExtentionsConstants = [
  '.jpg',
  '.jpeg',
  '.png',
  '.gif',
  '.webp'
];
